<template>
  <div style="background: #333333;">
    <div class="warper w">
      <div class="warper_left">
        <div class="warper_wechat">
          <img src="../../assets/image/account_img.jpg" />
        </div>
        <div class="warper_wechat_title">关注检车家微信公众号即刻拥有您的检车专家</div>
      </div>
      <div class="warper_center">
        <div class="warper_center_title">联系我们</div>
        <div class="warper_center_icon">
          <i class="iconfont icondianhua" />
          <span>400-018-8858</span>
        </div>
        <div class="warper_center_icon">
          <i class="iconfont iconicon1" />
          <span>检车家</span>
        </div>
        <div class="warper_center_icon">
          <i class="iconfont iconicon" />
          <span>327114652</span>
        </div>
        <!-- <div class="warper_center_copy">版权属北京集车科技 京ICP备16055469号</div> -->
        <!-- <div class="warper_center_copy">备案号：京ICP备16055469号</div> -->
      </div>
      <div class="warper_right">
        <div class="warper_center_link">友情链接</div>
        <div class="warper_right_el-row">
          <div class="bg-purple" v-for="(item,index) in Arrlist" :key="index">
            <a :href="item.url" target="_blank">{{item.name}}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bottom">备案号：京ICP备16055469号</div> -->
    <div class="bottom"><a href="https://beian.miit.gov.cn/" target="target" class="beiAn">{{beiAn}}</a></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Arrlist: [],
      beiAn: "ICP备案号：蜀ICP备2022000118号",
    };
  },
  created() {
    this.getData();
    let host = window.location.host;
    switch (host) {
      case "www.jianchejia.com":
        this.beiAn = "ICP备案号：京ICP备16055469号-1";
        break;
      case "jianchejia.com":
        this.beiAn = "ICP备案号：京ICP备16055469号-1";
        break;
      case "jianchejia.cn":
        this.beiAn = "ICP备案号：京ICP备16055469号-1";
        break;
      case "www.jianchejia.cn":
        this.beiAn = "ICP备案号：京ICP备16055469号-1";
        break;
      case "www.jianchejia.net":
        this.beiAn = "ICP备案号：蜀ICP备2022000118号-1";
        break;
      case "www.jiancejia.com.cn":
        this.beiAn = "ICP备案号：蜀ICP备2022000118号-2";
        break;
      case "jianchejia.com.cn":
        this.beiAn = "ICP备案号：蜀ICP备2022000118号-3";
        break;
      case "www.jianchejia.com.cn":
        this.beiAn = "ICP备案号：蜀ICP备2022000118号-3";
        break;
      default:
        this.beiAn = "ICP备案号：蜀ICP备2022000118号";
        break;
    }
  },
  methods: {
    async getData() {
      const { data: res } = await this.$ajax.get(
        "/v1/website/friendly-link-partner?type=" + 2
      );
      if (res.code == 0) {
        this.Arrlist = res.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.beiAn:hover {
  color: #1d89f9;
}
.bottom {
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  padding-bottom: 20px;
  a {
    color: rgba(102, 102, 102, 1);
  }
}
.warper {
  justify-content: space-between;
  display: flex;
  .warper_left {
    width: 140px;
    height: 162px;
    margin: 40px 0 38px 0;
    .warper_wechat {
      width: 110px;
      height: 110px;
      margin: 0 16px 19px 14px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .warper_wechat_title {
      font-size: 14px;
      color: #afafaf;
    }
  }
  .warper_center {
    margin: 40px 0 38px 67px;
    .warper_center_title {
      margin-left: 29px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .warper_center_icon {
      margin-top: 15px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(175, 175, 175, 1);
      i {
        margin-right: 9px;
      }
    }
    .warper_center_copy {
      margin-top: 19px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
  }
  .warper_right {
    width: 600px;
    margin: 40px 0 38px 0;
    .warper_center_link {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
    .warper_right_el-row {
      width: 100%;
      margin-top: 14px;
      font-size: 14px;
      line-height: 25px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(175, 175, 175, 1);
      display: flex;
      justify-content: left;
      flex-wrap: wrap;
      flex: 1;
      .bg-purple {
        display: block;
        margin-right: 28px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(175, 175, 175, 1);
        a {
          color: rgba(175, 175, 175, 1);
        }
      }
    }
  }
  .bg-purple {
    text-align: center;
    font-size: 14px;
    color: #afafaf;
  }
}
</style>
